// @src/pre-deployment/src/components/TrackingService/utils/PathBuilders.js v2.0
// - Migrated from src/pre-deployment/src/tracking/pathBuilders.js
// - Part of TrackingService component migration
// - Provides Firestore path and reference builders for tracking documents

import { doc } from 'firebase/firestore';

import { db } from '../../../services/firebase.js';

/**
 * Build path string for LearningProgress document
 * @param {string} userId - User ID
 * @param {number|string} level - Learning level
 * @param {number|string} chapter - Chapter number
 * @returns {string} Firestore path string
 */
export const getLearningProgressPath = (userId, level, chapter) =>
    `users/${userId}/level_${level}/chapter_${chapter}/Learn/LearningProgress`;

/**
 * Build path string for Mastery document
 * @param {string} userId - User ID
 * @param {number|string} level - Learning level
 * @param {number|string} chapter - Chapter number
 * @returns {string} Firestore path string
 */
export const getMasteryPath = (userId, level, chapter) =>
    `users/${userId}/level_${level}/chapter_${chapter}/Learn/Mastery`;

/**
 * Get Firestore DocumentReference for LearningProgress
 * @param {string} userId - User ID
 * @param {number|string} level - Learning level
 * @param {number|string} chapter - Chapter number
 * @returns {import('firebase/firestore').DocumentReference} Firestore document reference
 */
export const getLearningProgressRef = (userId, level, chapter) =>
    doc(db, getLearningProgressPath(userId, level, chapter));

/**
 * Get Firestore DocumentReference for Mastery
 * @param {string} userId - User ID
 * @param {number|string} level - Learning level
 * @param {number|string} chapter - Chapter number
 * @returns {import('firebase/firestore').DocumentReference} Firestore document reference
 */
export const getMasteryRef = (userId, level, chapter) =>
    doc(db, getMasteryPath(userId, level, chapter));

const PathBuilders = {
    getLearningProgressPath,
    getMasteryPath,
    getLearningProgressRef,
    getMasteryRef
};
export default PathBuilders;
